import React from 'react'

const RenameIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            className="h-5 w-5 rename-icon"
            aria-hidden="true"
            focusable="false"
        >

            <path d="M12 20h9" />
            <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L8 18l-4 1 1-4L16.5 3.5z" />

            <path d="M15 5l4 4" />
        </svg>
    )
}

export default RenameIcon
